var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _rect, _path8, _path9, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 249.71 110.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0047af;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.69,0H0v75.69h75.69V0ZM42.52,60.14h-9.35V15.55h9.35v44.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.74,0h-75.69v75.69h75.69V0ZM143.02,60.14h-10.58l-7.04-31.47c-.19-1.02-.37-1.88-.43-2.96h-.25c-.06,1.08-.12,1.94-.31,2.96l-7.04,31.47h-10.61l-10.8-44.59h9.47l6.36,30.83c.25,1.39.37,2.31.43,3.39h.19c.06-1.02.25-2.01.56-3.39l7.22-30.83h9.41l7.28,30.83c.31,1.39.43,2.38.49,3.39h.19c.06-1.08.12-2.01.43-3.39l6.36-30.83h9.47l-10.8,44.59Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.57,28.33v-.03c0-3.21-1.88-5.96-7.22-5.96h-7.9v11.82h7.9c5.52,0,7.22-2.84,7.22-5.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.46,40.64v.03h-9.04v12.68h8.73c5.4,0,7.53-2.96,7.53-6.48,0-3.7-2.31-6.23-7.22-6.23Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.01,0v75.69h75.69V0h-75.69ZM217.31,60.17l.03-.03h-20.3V15.55h19.35c10.61,0,14.81,5.4,14.81,11.57,0,4.6-2.72,8.49-7.84,9.87,5.65.86,9.04,4.78,9.04,10.74,0,6.67-4.6,12.44-15.09,12.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.28,91.93l-6.24,18.37h2.45l1.91-5.78h6.51l1.96,5.78h2.53l-6.27-18.37h-2.86ZM88.89,102.67l1.8-5.31c.35-1.12.65-2.24.93-3.33h.05c.27,1.06.54,2.15.95,3.35l1.8,5.29h-5.53Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.11 110.3 104.48 110.3 104.48 101.99 111.43 101.99 111.43 100.02 104.48 100.02 104.48 93.92 112 93.92 112 91.93 102.11 91.93 102.11 110.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.23,101.55v-.08c1.93-.65,3.46-2.26,3.46-4.69,0-1.42-.52-2.67-1.44-3.49-1.14-1.04-2.78-1.5-5.31-1.5-1.63,0-3.35.14-4.55.38v18.12h2.37v-7.96h2.23c2.15.08,3.13,1.04,3.68,3.57.52,2.29.93,3.87,1.23,4.39h2.45c-.38-.71-.82-2.48-1.42-5.04-.44-1.91-1.28-3.22-2.7-3.71ZM120.18,100.54h-2.43v-6.7c.38-.11,1.2-.22,2.34-.22,2.51.03,4.22,1.06,4.22,3.43,0,2.1-1.61,3.49-4.14,3.49Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.05,
    y: 91.93,
    width: 2.37,
    height: 18.37
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.15,93.62c1.53,0,2.81.33,3.71.76l.57-1.94c-.63-.33-2.07-.82-4.36-.82-5.7,0-9.59,3.9-9.59,9.65s3.9,9.29,9.07,9.29c2.24,0,3.98-.44,4.85-.87l-.49-1.88c-.95.46-2.42.76-3.87.76-4.47,0-7.06-2.89-7.06-7.39,0-4.82,2.86-7.58,7.17-7.58Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.33,91.93l-6.24,18.37h2.45l1.91-5.78h6.51l1.96,5.78h2.54l-6.27-18.37h-2.86ZM155.94,102.67l1.8-5.31c.35-1.12.65-2.24.93-3.33h.05c.27,1.06.55,2.15.95,3.35l1.8,5.29h-5.53Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.55,
    y: 103.07,
    width: 61.21,
    height: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 172.1,
    y: 103.07,
    width: 61.21,
    height: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.f1a72f657497b60c0454f8afdecc2575.svg";
export { ForwardRef as ReactComponent };